<template>
  <el-dialog
    title="课程续期"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="extendForm"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="课程名称">
        <span>{{ courseData ? courseData.courseName : '-' }}</span>
      </el-form-item>

      <el-form-item label="当前到期">
        <span>{{ courseData ? courseData.expireDate : '-' }}</span>
      </el-form-item>

      <el-form-item label="续期天数" prop="extendDays">
        <el-input-number
          v-model="formData.extendDays"
          :min="30"
          :max="730"
          :step="30"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399">天</span>
      </el-form-item>

      <el-form-item label="续期后到期">
        <span class="new-expire-date">{{ newExpireDate }}</span>
      </el-form-item>

      <el-form-item label="续期价格" prop="price">
        <el-input-number
          v-model="formData.price"
          :min="0"
          :max="9999"
          :precision="2"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399">元</span>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="2"
          placeholder="请输入备注信息"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        确认续期
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExtendCourseDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    courseData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      formData: {
        extendDays: 180,
        price: 0,
        remark: '',
      },
      formRules: {
        extendDays: [{ required: true, message: '请输入续期天数', trigger: 'blur' }],
        price: [{ required: true, message: '请输入续期价格', trigger: 'blur' }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    newExpireDate() {
      if (!this.courseData || !this.courseData.expireDate || !this.formData.extendDays) {
        return '-';
      }
      const date = new Date(this.courseData.expireDate);
      date.setDate(date.getDate() + this.formData.extendDays);
      return date.toISOString().split('T')[0];
    },
  },
  methods: {
    /**
     * 对话框打开时
     */
    handleOpen() {
      this.resetForm();
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        extendDays: 180,
        price: 0,
        remark: '',
      };
      this.$nextTick(() => {
        if (this.$refs.extendForm) {
          this.$refs.extendForm.clearValidate();
        }
      });
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.extendForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.submitting = true;
        try {
          // 这里应该调用续期API
          await new Promise((resolve) => setTimeout(resolve, 1000));
          this.$message.success('续期成功');
          this.$emit('success');
          this.handleClose();
        } catch (error) {
          console.error('续期失败:', error);
          this.$message.error('续期失败');
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.new-expire-date {
  color: #67c23a;
  font-weight: 600;
}
</style>
